export default __webpack_public_path__ + "static/media/cards_throw_away.f21cfc2d.mp3";